import { render, staticRenderFns } from "./dialog_InspectionNew.vue?vue&type=template&id=5d5777f8&scoped=true&"
import script from "./dialog_InspectionNew.vue?vue&type=script&lang=js&"
export * from "./dialog_InspectionNew.vue?vue&type=script&lang=js&"
import style0 from "./dialog_InspectionNew.vue?vue&type=style&index=0&id=5d5777f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5777f8",
  null
  
)

export default component.exports